// src/main.jsx
import * as Sentry from "@sentry/react";
import React from "react";
import ReactDOM from "react-dom/client";
// O SIMEMP está sendo desativado: o site mostra só o aviso e as solicitações do Ploomes, sem login.
// Para reabrir o sistema, volte a importar App de "./app" e "./shared/styles/index.css" e
// renderize <App /> no lugar de <PublicSite />.
import PublicSite from "./app/public-site/PublicSite";

const sentryDsn = import.meta.env.VITE_SENTRY_DSN?.trim();
if (sentryDsn && import.meta.env.MODE === "production") {
  Sentry.init({
    dsn: sentryDsn,
    environment: import.meta.env.MODE,
    tracesSampleRate: Number(import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE || "0.1"),
    beforeSend(event, hint) {
      const err = hint?.originalException;
      const name = err?.name ?? event?.exception?.values?.[0]?.type;
      if (name === "AbortError" || name === "NetworkError") return null;
      return event;
    },
  });
}

// Silencia aviso de compatibilidade do AntD v5 com React 19 somente em dev
if (import.meta && import.meta.env && import.meta.env.DEV) {
  const __origWarn = console.warn;
  console.warn = (...args) => {
    try {
      const msg = typeof args[0] === "string" ? args[0] : "";
      if (msg.includes("[antd: compatible] antd v5 support React is 16 ~ 18"))
        return;
    } catch {}
    return __origWarn(...args);
  };
}

ReactDOM.createRoot(document.getElementById("root")).render(<PublicSite />);
